import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import styles from "./AjusteInventario.module.css";
import History from "../../components/history";
import { Button, Form, Table, Row, Col } from "react-bootstrap";
import { useCookies } from 'react-cookie';
import axios from 'axios';
import Notifications, {notify} from "react-notify-toast";
import AjusteInventarioModal from "./AjusteInventarioModal/AjusteInventarioModal";

const AjusteInventario = (props) => {

    const loadingBtn = require("../../assets/loaders/btn-loading.gif");

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);

    const [loading, setLoading] = useState(false);
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const [movements, setMovements] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [year, setYear] = useState(new Date().getFullYear());

    const history = [
        {
            name: "Inicio",
            path: "/"
        },
        {
            name: "Movimientos",
            path: "/movimientos"
        }
    ]

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }

    const handleRealChange = (index, newValue) => {
    setMovements(prevMovements => {
        const updatedMovements = [...prevMovements];
        updatedMovements[index] = {
        ...updatedMovements[index],
        real: newValue
        };
        return updatedMovements;
    });
    };

    const handleAddMovement = (movement) => {
        setMovements(prev => [...prev, movement]);
    };

    const guardarCambios = (e) => {
        e.preventDefault();
        setLoadingGuardar(true);
        let currentFarm = cookie.kUserSession.data["farm"];
        let url =  "inventario/ajustar";
        let payload = {
            idEstancia: currentFarm.id,
            periodo: year,
            ajustes: movements
        };
        axios.post(process.env.REACT_APP_API_URL + url, payload,  prepareHeaders())
        .then(response => {
            setLoadingGuardar(false);
            preview();
        })
        .catch(error => {
            console.error(error);
            setLoadingGuardar(false); 
            preview();
        });
    }


    const preview = () => {
        setLoading(true);
        var currentFarm = cookie.kUserSession.data["farm"];
        var url =  "inventario?id_estancia=" + currentFarm.id + "&periodo=" + year;
        axios.get(process.env.REACT_APP_API_URL + url, prepareHeaders())
        .then(response => {
            var data = response.data;
            setMovements(data.map(item => ({ ...item, real: item.existencia })));
            setLoading(false);
        })
        .catch(error => {
            console.error(error);
            setLoading(false); 
            setMovements([]);
        });
    }

    useEffect(() => {
        preview();
    }, []);

    useEffect(() => {
        preview();
    }, [year]);

    return (
        <>
            <AjusteInventarioModal show={showModal} handleClose={() => setShowModal(false)} handleAdd={handleAddMovement} />
            <Notifications />
            <Header history={props.history} />
            <section className={styles.body}>
                <Row>
                    <Col>
                        <History items={history} current={"Ajustes de inventario"} history={props.history} />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <section className={styles.side}> 
                            <Form className={styles.searchForm}>
                                <Row>
                                    <Col>
                                        <Form.Group style={{marginBottom: "15px"}}>
                                            <Form.Label htmlFor="periodo" className={styles.label}>Periodo</Form.Label>
                                            <Form.Control id="periodo" className={"karanda-input"} value={year} onChange={(e) => {setYear(e.target.value); }} type="number"/>
                                        </Form.Group>                                
                                    </Col>
                                </Row>                                    
                                <Row>
                                    <Col>
                                        <Button className="karanda-btn" disabled={loading} style={{ height: "fit-content", marginTop: "auto" }} onClick={preview}>
                                            Buscar
                                            {
                                                loading ? (
                                                    <>
                                                        &nbsp;&nbsp;<img src={loadingBtn} height="15" />
                                                    </>
                                                ) : <></>
                                            }
                                        </Button>                                    
                                    </Col>
                                </Row>
                            </Form>                        
                        </section>
                    </Col>
                    <Col>
                        <section className={styles.content}>
                            <h1 className={styles.title}>Inventario periodo {year-1}/{year}</h1>
                            <section className={styles.actions}>
                                {
                                    movements.length == 0 ? (
                                        <>
                                            <br></br>
                                            <span>No hay registros que mostrar</span>
                                        </>
                                    ) : <></>
                                }
                                {
                                    loading ? (
                                        <span>Cargando...</span>
                                    ) : (
                                        <>
                                            <div style={{ width: "100%", textAlign: "right", marginBottom: "10px" }}>
                                                <Button className="karanda-btn" onClick={() => setShowModal(true)}>Agregar</Button>
                                            </div>
                                            <Table bordered hover responsive>
                                                <thead>
                                                    <tr>
                                                        <th>Categoria</th>
                                                        <th>Carimbo</th>
                                                        <th>Existencias</th>
                                                        <th>Recuento de inventario</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        movements.map((movement, index) => (
                                                            <tr key={index}>
                                                                <td>{movement.nombre}</td>
                                                                <td>{movement.carimbo}</td>
                                                                <td>{movement.existencia}</td>
                                                                <td>
                                                                    <Form.Control type="number" value={movement.real} onChange={(e) => handleRealChange(index, e.target.value)} />
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </Table>
                                            <div style={{  width: "100%", textAlign: "right"}}>
                                                <Button className="karanda-btn"  style={{ marginLeft: "auto"}} onClick={guardarCambios} disabled={loadingGuardar}>
                                                    Guardar cambios
                                                    {
                                                        loadingGuardar ? (
                                                            <>
                                                                &nbsp;&nbsp;<img src={loadingBtn} height="15" />
                                                            </>
                                                        ) : <></>
                                                    }
                                                </Button>

                                            </div>
                                        </>
                                    )
                                }

                            </section>
                        </section>                    
                    </Col>          
                </Row>
            </section>
        </>
    );

};

export default AjusteInventario;